import axios from "axios";
import APPLICATION_LIST, { BASIC_LOGIN_APP_LIST } from "./application-list";
import { countryObj } from "../../utils/countryName";
import { monthNames } from "./date";

class Helper {
    GetAppName = (value: string) => {
        let AppName = value;
        APPLICATION_LIST.map((item) => {
            if (item.value === value) {
                AppName = item.text;
            }
            return value;
        });
        return AppName;
    };

    GetBasicLoginAppName = (value: string) => {
        let AppName;
        BASIC_LOGIN_APP_LIST.map((item) => {
            if (item.applicationId === value) {
                return (AppName = item.applicationName);
            }
            return null;
        });
        return AppName;
    };

    GetCountryName = (value: string) => {
        let CountryName = value;
        Object.entries(countryObj).forEach(([key, val]) => {
            if (key === value) CountryName = val;
        });
        return CountryName;
    };

    GetGender = (value: string) => {
        return value.toUpperCase() === "M" ? "Male" : "Female";
    };

    strToArray = (str: string) => (str?.length ? str.split(",").map((item) => item.trim()) : []);

    arrToString = (arr: string[]) => arr.toString().trim();
    getDate = (date: Date) => {
        date = new Date(date);
        return `${monthNames[date.getMonth()]} ${date.getDate().toString()}, ${date.getFullYear()}`;
    };

    getFormatedDateTime = (dateString: string) => {
        const dateTime = new Date(dateString);

        const formattedDateTime = dateTime.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
        return formattedDateTime;
    };

    aemInvalidateCache = () => {
        const apiInfo = {
            url: `${process.env.REACT_APP_API_BASE_URL}/abbvie-pro/aem/invalidate-cache`,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: "",
        };
        return new Promise((resolve, reject) => {
            axios({
                url: apiInfo.url,
                method: apiInfo.method,
                headers: apiInfo.headers,
                data: apiInfo.data,
            })
                .then((result) => {
                    resolve(result.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    accessNestedObject<T>(obj: T, keyString: string): any {
        const keys = keyString.split(".");
        let currentObj: any = obj;

        for (const key of keys) {
            if (currentObj && typeof currentObj === "object" && key in currentObj) {
                currentObj = currentObj[key];
            } else {
                return undefined;
            }
        }

        return currentObj;
    }
}

export default new Helper();
